import { Controller } from 'react-hook-form';

import Checkbox from '../../../../components/Checkbox/Checkbox';

import type { IMAIroQuestionSwitcherProps } from '../interfaces/IMAIroQuestionSwitcherProps';

import styles from '../scss/MAIROQuestion.module.scss';

function MAIROQuestionSwitcher({
  question,
  control,
  onOpenReasonModal,
  setValue,
  currentValue,
  questionIndex,
  handleHideThirdStep,
}: IMAIroQuestionSwitcherProps) {
  return (
    <div className={styles.questionWrapper}>
      <div className={styles.name}>
        <p>{question.name}</p>
      </div>
      <div className={styles.switch}>
        <Controller
          key={`questions.${questionIndex}.answer.selectedOptionId`}
          control={control}
          name={`questions.${questionIndex}.answer.selectedOptionId`}
          defaultValue={currentValue}
          render={({ field: { onChange, value } }) => (
            <>
              {question.options.map(({ name, id }) => (
                <Checkbox
                  key={id}
                  name={name}
                  checked={value === id}
                  value={id}
                  type="radio"
                  label={(
                    <div className={styles.label}>
                      <span>{name}</span>
                    </div>
                  )}
                  onChange={() => {
                    onChange(id);
                    setValue(`questions.${questionIndex}.answer.selectedOptionId`, id);

                    if (handleHideThirdStep && name === 'Potential') {
                      handleHideThirdStep(true);
                    } else if (handleHideThirdStep && name === 'Actual') {
                      handleHideThirdStep(false);
                    }

                    if ((name === 'Potential' || name === 'Negative') && onOpenReasonModal) {
                      onOpenReasonModal(true, questionIndex);
                    }
                  }}
                />
              ))}
            </>
          )}
        />
      </div>
    </div>
  );
}

export default MAIROQuestionSwitcher;
